import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Redirect, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setCookie, getCookie } from "../../utils/cookies";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
//import { detect } from 'detect-browser';
import Bowser from "bowser";
// layout
import Wrapper from "../layout/wrapper";
import Header from "../layout/header";
import LoadingView from "../layout/loading";
// services
import { login, getCurrenUser } from "../../services/users";
import { getEvalutionStatus, getCheckNetwork } from "../../services/test";

//const browser = detect();
const googleChrome = 'Chrome';
const browser = Bowser.getParser(window.navigator.userAgent);
const Login = () => {
  const location = useLocation();
  // state
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setloading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [isValidNetwork, setIsValidNetwork] = useState(true);

  useEffect(() => {
    const token = getCookie("mentaliaUserToken");
    if (token && token != "undefined") {
      setloading(true);
      getUserInfo(token);
    } else {
      setloading(false);
      getInfoTest(false);
    }
    
  }, []);

  // // Redux hooks
  const userToken = useSelector((state) => state.user.token);
  const dispatch = useDispatch();

  // // Redux action
  const setUser = (token, name, lastName, avatar, profileName, evaluationName, sedema_microphone_unactive) => {
    dispatch({
      type: "SET_USER_INFO",
      payload: { token, name, lastName, avatar, profileName, evaluationName, sedema_microphone_unactive },
    });
  };

  const getInfoTest = async (isLogin) => {
    setloading(true);
    const resp = await getEvalutionStatus();
    setShowForm(resp);
    if(!isLogin && resp){
      const respNW = await getCheckNetwork();
      if(respNW){
        if(browser.getBrowserName() === googleChrome)
          setIsValidNetwork(true);
        else setIsValidNetwork(false);
      }else{
        setIsValidNetwork(true);
      }
      
    }
    setloading(false);
  };

  const loginUser = async () => {
    if (email && password) {
      setloading(true);
      try {
        const loggedUser = await login(email, password);
        setloading(false);
        if (!loggedUser) {
          setCookie("mentaliaUserToken", undefined);
          setCookie("email", undefined);
          setUser(null);
          setError(true);
          setErrorMessage("Hubo un error, intenta iniciar sesión de nuevo");
          return error;
        }
        if (loggedUser.private_message === "Usuario no encontrado") {
          setError(true);
          setErrorMessage("Correo o contraseña incorrectos");
          return;
        }
        setCookie("mentaliaUserToken", loggedUser.token);
        setCookie("email", email);
        setUser(
          loggedUser.token,
          loggedUser.first_name,
          loggedUser.last_name,
          loggedUser.avatar,
          loggedUser.profile_name,
          loggedUser.evaluation_name
        );
        getUserInfo(loggedUser.token);
      } catch (error) {
        setloading(false);
        setError(true);
        setErrorMessage("Hubo un error, intenta iniciar sesión de nuevo");
        console.error(error);
      }
    } else {
      setError(true);
    }
  };

  const getUserInfo = async (userToken) => {
    try {
      setloading(true);
      const userInfo = await getCurrenUser(userToken);
      getInfoTest(true);
      if (!userInfo || userInfo.error) {
        setCookie("mentaliaUserToken", undefined);
        setloading(false);
        setUser(null);
        setError(true);
        setErrorMessage("Hubo un error, intenta iniciar sesión de nuevo");
        return error;
      }

      setUser(
        userToken,
        userInfo.first_name,
        userInfo.last_name,
        userInfo.avatar,
        userInfo.profile_name,
        userInfo.evaluation_name,
        userInfo.microphone_unactive
      );
      setloading(false);
    } catch (error) {
      setCookie("mentaliaUserToken", undefined);
      setUser(null);
      console.error(error);
    }
  };

  const onKeyUp = key => {
    if (key.keyCode === 13) loginUser();
  }

  console.log('#browser#', browser.getBrowserName());

  return (
    <LoginStyled>
      {userToken ? (
        <Redirect
          to={location.state ? location.state.from.pathname : "/test"}
        />
      ) : null}
      <Header title="Mentalia" />
      {loading ? (
        <LoadingView message="Cargando..." />
      ) : showForm ? (
        isValidNetwork ?
        <Wrapper>
          <form className="login-container">
            <h2>Iniciar Sesión</h2>
            <TextField
              className="login-element"
              label="Usuario o correo"
              variant="outlined"
              type="email"
              autoComplete="username"
              value={email}
              error={error}
              helperText={errorMessage}
              onChange={(event) => {
                setEmail(event.target.value);
                setError(false);
                setErrorMessage("");
              }}
              onKeyUp={onKeyUp}
            />
            <TextField
              className="login-element"
              label="Contraseña"
              variant="outlined"
              type="password"
              autoComplete="current-password"
              value={password}
              error={error}
              onChange={(event) => {
                setPassword(event.target.value);
                setError(false);
                setErrorMessage("");
              }}
              onKeyUp={onKeyUp}
            />
            <Button
              className="login-element"
              variant="contained"
              color="primary"
              disabled={loading}
              onClick={() => {
                loginUser();
              }}
            >
              Entra
            </Button>
          </form>
        </Wrapper>
        : 
        <div className="title-statusTest">
          <h2>
          Para poder realizar la prueba necesitas utilizar el explorador Google Chrome
          </h2>
        </div>
      ) : (
        <div className="title-statusTest">
          <h2>
            Por ahora la evaluación no está activa
          </h2>
        </div>
      )}
    </LoginStyled>
  );
};

const LoginStyled = styled.section`
  .login-container {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 80px);
    justify-content: center;
    text-align: center;
    padding-bottom: 25vh;
    margin: 0 auto;
    max-width: 300px;
  }

  .login-element {
    margin: 10px 0;
  }

  .title-statusTest{
    text-align: center;
    padding-top: 45px;
  }
`;

export default Login;
